import { TwinTranslationTF } from '../../hooks/useTwinTranslation';
import { TwinDictionary } from '../dictionary';
import { InputTableLayoutData } from '../../../baseComponents/TwinTable/InputTableLayout/types';
import { QuoteOrderTypeShippingInversed } from '@teinor/erp/types/company/order/quote/quoteOrder';
import { getConfigParam, getUserPermissions } from '../../reducers/getters';
import { permissionCheck } from '../../../baseComponents/PermissionChecker/function';
import { TwinParameters } from '@teinor/erp/types/company/config/parameter';
import { checkIfSelectedProductsAreOkForSend } from '../product/uniqueNumber';

export const notHaveCountersWorkingCenter = (items: TwinDictionary) => {
    for (const key in items) {
        const item= items[key]
        items[key] = { ...item, is_blocked: !(item.WorkingCenterCounters?.length > 0) }
    }
    return items
}

const getQuoteShippingInfoMessage = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    const quoteShippingByDefault = getConfigParam('quoteShippingMandatory')
    if ((orderData?.header?.typeShipping === null || orderData?.header?.typeShipping === '') && (!quoteShippingByDefault || quoteShippingByDefault === 'on')) {
        return t('mustHaveShipping', 'Debes seleccionar tipo de envío para continuar') 
    } else if (orderData.header.typeShipping && !orderData.header?.OrderShippingId && !orderData.header?.OrderShipping?.id && (!orderData.header.typeShipping || parseInt(orderData.header.typeShipping) === QuoteOrderTypeShippingInversed['sendToCustomer'])) {
        return t('mustHaveShippingToContinue', 'Debes seleccionar un transporte para continuar')
    } else if (parseInt(orderData.header.typeShipping) === QuoteOrderTypeShippingInversed['sendToCustomer'] && orderData?.header?.OrderShipping?.ShippingServices && orderData?.header?.OrderShipping?.ShippingServices.length === 0 && !orderData?.header?.OrderShipping?.ShippingService) {
        return t('mustHaveShippingServicesToContinue', 'Debe tener servicios de transportistas para continuar')
    }
    return null
}

const checkHaveProductsLength = (originalTableData: { [fieldName: string]: any; }[] | undefined, t: TwinTranslationTF) => {
    return originalTableData?.length ? null : t('mustAddProducts', 'Debes añadir productos para continuar')
}
const checkHaveProcessedDate = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    return orderData?.header?.processed_date?.length ? null : t('mustAddProcessedDate', 'Debes añadir fecha del presupuesto para continuar')
}
const checkHaveSerie = (orderData: InputTableLayoutData, t: TwinTranslationTF) => {
    return orderData?.header?.WorkingCenterCounterId ? null : t('mustAddWorkingCenterCounter', 'Debes añadir una serie para continuar')
}

export const checkQuoteFromOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = checkHaveProductsLength(orderData.originalTableData, t)
        if (result) {
            return result
        }
        result = checkHaveSerie(orderData, t)
        if (result) {
            return result
        }
        result = getQuoteShippingInfoMessage(orderData, t)
        if (result) {
            return result
        }
        result = checkHaveProcessedDate(orderData, t)
        if (result) {
            return result
        }
    }
}
export const checkIfCanCreateQuote = (t: TwinTranslationTF, workingCenter?: TwinDictionary) => {
    let error: false | string = false;
    if (!workingCenter) {
        error = t('notCreateQuoteInNotWorkingCenter', 'No puedes crear un presupuesto porque no tienes centro de trabajo')
    } else if (!workingCenter.CurrencyId) {
        error = t('notCreateQuoteInNotWorkingCenterCurrencyId', 'No puedes crear un presupuesto porque este centro de trabajo no tiene moneda asignada')
    } else if (!workingCenter.address || !workingCenter.city || !workingCenter.postal_code || !workingCenter.state) {
        error = t('notCreateQuoteInNotWorkingCenterAddress', 'No puedes crear un presupuesto porque este centro de trabajo no tiene una dirección fiscal completa')
    }
    return error
}

export const checkSellDeliveryNoteFromQuoteOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = null
        const userPermission = getUserPermissions('sell.deliveryNote')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateSellDeliveryNote', 'No tienes permisos para crear albaranes de venta')
        }
        const quoteToFinished = getConfigParam('quoteToDeliveryNoteFinished') as TwinParameters['quoteToDeliveryNoteFinished']
        const nextStepFinished = quoteToFinished === 'on' ? true : false
        if (nextStepFinished){
            result = getQuoteShippingInfoMessage(orderData, t)
            if (result) {
                return result
            }
            result = checkIfSelectedProductsAreOkForSend(orderData.selectedTableData?.length ? orderData.selectedTableData : orderData.tableData)
            if (!result) {
                return t('addSameQuantitySerialLotNumberProducts', 'Debes añadir los números únicos correspondientes a la cantidad indicada del producto')
            }
        }
    }
}

export const checkSellInvoiceFromQuoteOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = null
        const userPermission = getUserPermissions('sell.invoice')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateSellInvoice', 'No tienes permisos para crear facturas de venta')
        }
        const quoteToFinished = getConfigParam('quoteToInvoiceFinished') as TwinParameters['quoteToInvoiceFinished']
        const nextStepFinished = quoteToFinished === 'on' ? true : false
        if (nextStepFinished){
            result = getQuoteShippingInfoMessage(orderData, t)
            if (result) {
                return result
            }
            result = checkIfSelectedProductsAreOkForSend(orderData.selectedTableData?.length ? orderData.selectedTableData : orderData.tableData)
            if (!result) {
                return t('addSameQuantitySerialLotNumberProducts', 'Debes añadir los números únicos correspondientes a la cantidad indicada del producto')
            }
        }
    }
}
export const checkSellOrderFromQuoteOrderAllOk = (orderData: InputTableLayoutData | null, t: TwinTranslationTF) => {
    if (orderData) {
        let result = null
        const userPermission = getUserPermissions('sell.order')
        if (!permissionCheck(userPermission, 'create')) {
            return t('notPermissionsCreateSellOrder', 'No tienes permisos para crear pedidos de venta')
        }
        result = checkIfSelectedProductsAreOkForSend(orderData.selectedTableData?.length ? orderData.selectedTableData : orderData.tableData)
        if (!result) {
            return t('addSameQuantitySerialLotNumberProducts', 'Debes añadir los números únicos correspondientes a la cantidad indicada del producto')
        }
    }
}